import React from "react";

import { trpc } from "@blis/trpc/react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogBody,
  DialogCloseButton,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Label } from "@/components/ui/field";
import { Modal } from "@/components/ui/modal";
import {
  Select,
  SelectItem,
  SelectList,
  SelectTrigger,
} from "@/components/ui/select";
import { mutationResponse } from "@/utils/trpc";

export function UpdateSampleUsedDialog({
  children,
  result,
  accessionId,
}: {
  children: React.ReactNode;
  accessionId: number;
  result: {
    id: number;
    sample: { id: number; displayId?: string | null } | null;
  };
}) {
  const [selectedSampleId, setSelectedSampleId] = React.useState<number | null>(
    result.sample?.id || null,
  );
  const [open, setOpen] = React.useState(false);
  const samples = trpc.accession.samples.useQuery(accessionId);
  const options =
    samples.data?.map((sample) => {
      return {
        value: sample.id,
        label: `${sample.displayId} - ${sample.tube.name}`,
      };
    }) || [];

  const mutate = trpc.results.updateSample.useMutation(
    mutationResponse({
      successMessage: "Sample updated",
      errorTitle: "Failed to update sample",
      onSuccess() {
        setOpen(false);
      },
    }),
  );
  const onSubmit = (sampleId: number) => {
    mutate.mutate({ id: result.id, sampleId });
  };
  return (
    <DialogTrigger isOpen={open} onOpenChange={setOpen}>
      {children}
      <Modal>
        <Dialog>
          <DialogHeader>
            <DialogTitle>Update sample used</DialogTitle>
          </DialogHeader>
          <DialogBody>
            <Select
              selectedKey={selectedSampleId}
              onSelectionChange={(e) => {
                setSelectedSampleId(e as number | null);
              }}
            >
              <Label>Sample</Label>
              <SelectTrigger />
              <SelectList>
                {options.map((sample) => {
                  return (
                    <SelectItem
                      key={sample.value}
                      id={sample.value}
                      textValue={sample.label}
                    >
                      {sample.label}
                    </SelectItem>
                  );
                })}
              </SelectList>
            </Select>
          </DialogBody>
          <DialogFooter>
            <Button
              onClick={() => {
                if (selectedSampleId) {
                  onSubmit(selectedSampleId);
                }
              }}
              isPending={mutate.isPending}
              isDisabled={!selectedSampleId}
            >
              Update
            </Button>
            <DialogCloseButton>Cancel</DialogCloseButton>
          </DialogFooter>
        </Dialog>
      </Modal>
    </DialogTrigger>
  );
}
